import {
  Component,
  computed,
  inject,
  ChangeDetectionStrategy,
} from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { MatTabLink, MatTabNav, MatTabNavPanel } from "@angular/material/tabs";
import {
  ActivatedRoute,
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
} from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";
import { map } from "rxjs";
import { ProductDetailBreadcrumb } from "../../shared/components/breadcrumb/breadcrumb";
import { ConfigService } from "../../shared/config/config.service";
import {
  pathParamsHelper,
  pathRouteDataHelper$,
  pathRouteParametersHelper$,
} from "../../shared/helpers/path-params.helper";
import { DefaultProduct } from "../../shared/pia-api/generated";

@Component({
  selector: "claas-products-compare",
  imports: [
    ProductDetailBreadcrumb,
    TranslatePipe,
    MatTabLink,
    MatTabNav,
    MatTabNavPanel,
    RouterLinkActive,
    RouterOutlet,
    RouterLink,
  ],
  templateUrl: "./products-compare.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./products-compare.scss",
})
export class ProductsCompare {
  config = inject(ConfigService);
  route = inject(ActivatedRoute);
  data = toSignal(pathRouteDataHelper$());
  params = toSignal(pathRouteParametersHelper$());
  argumentsTabActive = computed(() => {
    const { deepPath } = pathParamsHelper(this.route.snapshot);
    return (
      deepPath?.includes("product") &&
      deepPath?.includes("arguments") &&
      deepPath?.includes("comparison")
    );
  });
  techDataTabActive = computed(() => {
    const { deepPath } = pathParamsHelper(this.route.snapshot);
    return (
      deepPath?.includes("product") &&
      deepPath?.includes("tech-data") &&
      deepPath?.includes("comparison")
    );
  });
  productSeries = computed(
    () => this.data()?.["productDetails"] as DefaultProduct | null,
  );
  product = computed(() => {
    const productId = this.params()?.["productId"];
    return this.data()?.["productDescendants"]?.find(
      (productDescendant: DefaultProduct) => {
        return productDescendant.ID === productId;
      },
    ) as DefaultProduct | null;
  });
  productID = toSignal(
    pathRouteParametersHelper$().pipe(
      map((params) =>
        params["productId"]
          ? encodeURIComponent(params["productId"] as string)
          : "",
      ),
    ),
    {
      initialValue: "",
    },
  );
  competitorID = toSignal(
    pathRouteParametersHelper$().pipe(
      map((params) =>
        params["competitorId"]
          ? encodeURIComponent(params["competitorId"] as string)
          : "",
      ),
    ),
    {
      initialValue: "",
    },
  );
}
